<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Toko</a></li>
                <li><a href="#/barang_toko">Barang</a></li>
            </ol>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Basic Tables-->
                <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-left" style="padding-left: 20px; padding-top: 10px;">
                          <h4><b>BARANG</b></h4>
                        </div>
                        <div class="pull-right" style="padding-right: 20px; padding-top: 10px;">
                          <el-select v-model="toko1" clearable filterable placeholder="Pilih Toko" style="width: 500px"
                              @change="handleSelect1">
                            <el-option
                              v-for="item in region"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                          &nbsp;
                          <el-button icon="el-icon-search" v-loading.fullscreen.lock="fullscreenLoading" circle @click="getData()"></el-button>
                          <el-button icon="el-icon-plus" type="success" circle @click="addData()" v-if="level.indexOf('ADMIN') !== -1"></el-button>
                        </div>
                    </div>
                    <div class="box-body">
                          <el-table v-loading="loadingModal" border hover
                          :data="tableData1"
                          style="width: 100%" max-height="550" responsive>
                          <el-table-column fixed="left"
                            label="#"
                            header-align="center"
                            align="center"
                            width="50px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{scope.row.no}}.
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column fixed="left"
                            label="SKU"
                            prop="sku"
                            header-align="center"
                            align="center"
                            width="100px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_sku" placeholder="Filter SKU" @keyup.native="cariSku()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.sku }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="BARANG"
                            prop="nama"
                            header-align="left"
                            align="left">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_nama" placeholder="Filter Nama" @keyup.native="cariNama()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.nama }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="SISA STOK"
                            prop="sisa_stok"
                            header-align="center"
                            align="left"
                            width="150px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{toMoney(scope.row.sisa_stok)}}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column label="PILIHAN" align="center" header-align="center" width="100px">
                            <template slot-scope="scope">
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Kartu Stok" placement="top-start">
                                <el-button type="primary" size="small" icon="ti-eye" @click="confirmStok(scope.row)"></el-button>
                              </el-tooltip>
                              <!-- <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Hapus" placement="top-start">
                                <el-button type="danger" size="small" icon="el-icon-delete" @click="confirmDel(scope.row)"></el-button>
                              </el-tooltip> -->
                            </template>
                          </el-table-column>
                        </el-table>

                      <br/>

                        <div align="right">
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="tableData.length"
                            :page-size="page_size"
                            :current-page="current_page"
                            @current-change="handleCurrentChange" >
                          </el-pagination>
                        </div>


                    </div>
                </div>

                <el-dialog title="Tambah Data" :visible.sync="dialogFormVisible" v-loading="loadingModalAdd" :before-close="handleClose" width="700px" top="1%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formAdd" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="Toko" prop="kode_toko">
                    <!-- <el-autocomplete
                      class="inline-input"
                      v-model="region1"
                      :fetch-suggestions="querySearch"
                      placeholder="Cari Toko"
                      @select="handleSelect"
                    ></el-autocomplete> -->
                    <el-select v-model="row1.kode_toko" clearable filterable placeholder="Pilih Toko"
                        @change="handleSelect">
                      <el-option
                        v-for="item in region"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                    <el-form-item label="Barang" prop="nama">
                      <el-input type="textarea" rows="5" v-model="row1.nama" disabled></el-input>
                    </el-form-item>
                  </el-form>
                    <el-row>
                      <!-- <el-col :span="10" class="grid-content">
                    <el-input
                      v-model="carinama"
                      placeholder="Cari Barang"
                      @keyup.native="handleSelect_"
                    ></el-input>
                  </el-col> -->
                    <el-col :span="14" class="grid-content">
                    </el-col>
                    <el-col :span="10" class="grid-content">
                      <div class="pull-right">
                        <el-button @click="dialogFormVisible = false" block>Batal</el-button>
                        <el-button type="primary" @click="confirmEdit1(0, row1, 'formAdd')" block>Simpan</el-button>
                      </div>
                    </el-col>
                  </el-row>
                  <!-- <div class="pull-right">
                      Search &nbsp;
                    <el-input
                      v-model="carinama"
                      placeholder="Cari Barang"
                      @change="handleSelect_"
                    ></el-input>
                  </div> -->
                  <el-table v-loading="loadingModalAdmin" border hover
                    :data="pegawai"
                      highlight-current-row
                      @selection-change="handleSelectionChange"
                      ref="multipleTable"
                    style="width: 100%" responsive>
                      <el-table-column
                        type="selection"
                        width="50">
                      </el-table-column>
                    <!-- <el-table-column fixed="left"
                      label="#"
                      width="50">
                      <template slot-scope="scope">
                          {{scope.$index + 1}}
                      </template>
                    </el-table-column> -->
                    <el-table-column fixed="left"
                      label="SKU"
                      width="100">
                      <template slot-scope="scope">
                          {{scope.row.sku}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Barang">
                      <template slot-scope="scope">
                          {{scope.row.nama}}
                      </template>
                    </el-table-column>
                  </el-table>
                    <!-- <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormVisible = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formAdd')">Simpan</el-button>
                    </span> -->
                </el-dialog>

                <el-dialog title="Edit Data" :visible.sync="dialogFormEdit" v-loading="loadingModalEdit" width="500px" top="1%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formEdit" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="Toko" prop="kode_toko">
                    <el-autocomplete
                      class="inline-input"
                      v-model="region1"
                      :fetch-suggestions="querySearch"
                      placeholder="Cari Toko"
                      @select="handleSelect"
                    ></el-autocomplete>
                  </el-form-item>
                    <el-form-item label="Nama" prop="nama">
                      <el-input type="text" v-model="row1.nama" disabled></el-input>
                    </el-form-item>
                  </el-form>
                    <el-row>
                      <el-col :span="10" class="grid-content">
                    <el-input
                      v-model="carinama"
                      placeholder="Cari Barang"
                      @keyup.native="handleSelect"
                    ></el-input>
                  </el-col>
                    <el-col :span="6" class="grid-content">
                    </el-col>
                    <el-col :span="8" class="grid-content">
                      <div class="pull-right">
                        <el-button @click="dialogFormEdit = false" block>Batal</el-button>
                        <el-button type="primary" @click="confirmEdit1(0, row1, 'formEdit')" block>Simpan</el-button>
                      </div>
                    </el-col>
                  </el-row>
                  <!-- <div class="pull-right">
                      Search &nbsp;
                    <el-input
                      v-model="carinama"
                      placeholder="Cari Barang"
                      @change="handleSelect"
                    ></el-input>
                  </div> -->
                  <el-table v-loading="loadingModalAdmin" border hover
                    :data="pegawai"
                      highlight-current-row
                      @current-change="handleCurrentChangePegawai"
                    style="width: 100%" responsive>
                    <el-table-column fixed="left"
                      label="#"
                      min-width="50">
                      <template slot-scope="scope">
                          {{scope.$index + 1}}
                      </template>
                    </el-table-column>
                    <el-table-column fixed="left"
                      label="SKU"
                      min-width="100">
                      <template slot-scope="scope">
                          {{scope.row.sku}}
                      </template>
                    </el-table-column>
                    <el-table-column fixed="left"
                      label="Nama"
                      min-width="300">
                      <template slot-scope="scope">
                          {{scope.row.nama}}
                      </template>
                    </el-table-column>
                  </el-table>
                    <!-- <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEdit = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formEdit')">Simpan</el-button>
                    </span> -->
                </el-dialog>

                <el-dialog :title="title_stok" :visible.sync="dialogStok" v-loading="loadingModalStok" width="95%" top="1%">
                  Bulan : 
                  <el-date-picker v-loading.fullscreen.lock="fullscreenLoading" @change='hitKartuStokService' 
                    v-model="value4"
                    style="width: 120px"
                    type="month"
                    placeholder="Pilih bulan">
                  </el-date-picker>
                  <br /><br />
                  <el-table border hover
                    :summary-method="getSummaries"
                    show-summary
                    :data="stok"
                    style="width: 100%" responsive>
                    <!-- <el-table-column fixed="left"
                      label="#"
                      header-align="center"
                      align="center"
                      width="50px">
                      <template slot-scope="scope">
                          {{scope.$index + 1}}.
                      </template>
                    </el-table-column> -->
                    <el-table-column
                      label="Tanggal"
                      header-align="left"
                      align="left"
                      prop="tanggal"
                      width="100">
                      <template slot-scope="scope">
                          {{scope.row.tanggal}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Stok Awal Aktual"
                      header-align="left"
                      prop="stok_awal_aktual"
                      align="left">
                      <template slot-scope="scope">
                          {{toMoney(scope.row.stok_awal_aktual)}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Stok Masuk Aktual"
                      header-align="left"
                      prop="stok_masuk_aktual"
                      align="left">
                      <template slot-scope="scope">
                          {{toMoney(scope.row.stok_masuk_aktual)}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Stok Keluar Aktual"
                      header-align="left"
                      prop="stok_keluar_aktual"
                      align="left">
                      <template slot-scope="scope">
                          {{toMoney(scope.row.stok_keluar_aktual)}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Stok Sisa Aktual"
                      header-align="left"
                      prop="stok_sisa_aktual"
                      align="left">
                      <template slot-scope="scope">
                          {{toMoney(scope.row.stok_sisa_aktual)}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Stok Keluar B.O.M"
                      prop="stok_keluar_bom"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                          {{toMoney(scope.row.stok_keluar_bom)}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Variance"
                      prop="variance"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                          <i class="material-icons">{{scope.row.icon}}</i>&nbsp;&nbsp;{{toMoney(scope.row.variance)}}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Rasio B.O.M"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                          <!-- <i class="material-icons">{{scope.row.icon}}</i> -->
                      </template>
                    </el-table-column>
                  </el-table>

                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogStok = false">Tutup</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormWilDel" v-loading="loadingModalDel" width="500px" top="1%">
                  <h4>Apakah Anda yakin akan menghapus data <b>{{ nama }}</b>?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilDel = false">Batal</el-button>
                    <el-button type="primary" @click="confirmDel1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Informasi" :visible.sync="dialogFormInfo" width="500px" top="1%">
                  <h5>{{message}}</h5>
                  <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="dialogFormInfo = false">Batal</el-button> -->
                    <el-button type="primary" @click="dialogFormInfo = false">OK</el-button>
                  </span>
                </el-dialog>
                <!-- End of Basic Tables-->
                
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    import Vue from 'Vue'
    import VueResource from 'vue-resource'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
    import VueCookie from 'vue-cookie'
    import moment from 'moment'
    Vue.use(VueCookie)

    import jsonUrl from '../../../assets/url.json'

    Vue.use(VueResource)

    export default {
      name: 'Wilayah',
      components: {
        ClipLoader
      },
      data: function () {
        var validateName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama wilayah'))
          } else {
            callback()
          }
        }
        var validateArea = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama area'))
          } else {
            callback()
          }
        }
        return {
          level: localStorage.level,
          region1: '',
          toko1: '',
          title_stok: '',
          row1: {kode: '', nama: '', edit: true},
          tableData: [],
          tableData1: [],
          tableData2: [],
          stok: [],
          value4: new Date(),
          rules: {
            name: [
              { validator: validateName, trigger: 'blur' }
            ]
          },
          rules2: {
            area: [
              { validator: validateArea, trigger: 'blur' }
            ]
          },
          cari_nama: '',
          cari_sisa_stok: '',
          cari_sku: '',
          carinama: '',
          cari_region: '',
          nama: '',
          kode_toko: '',
          kode_barang: '',
          region: [],
          pegawai: [],
          pegawai1: [],
          coba: false,
          dialogFormEdit: false,
          dialogFormVisible: false,
          dialogFormWilEdit: false,
          dialogFormWilDel: false,
          dialogFormArea: false,
          loadingModal: false,
          loadingModalAdd: false,
          loadingModalEdit: false,
          loadingModalArea: false,
          loadingModalTambah: false,
          loadingModalDel: false,
          dialogFormInfo: false,
          loadingModalStok: false,
          dialogStok: false,
          fullscreenLoading: false,
          form: {
            kode: '',
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
          },
          form1: {
            kode: '',
            name: ''
          },
          form2: {
            kode: '',
            name: '',
            area: ''
          },
          message: '',
          formLabelWidth: 'auto',
          rules3: {
            nama: [
              { required: true, message: 'Silahkan isi nama barang', trigger: 'change' }
            ]
          },
          listQuery: {
            page: 1,
            limit: 20,
            importance: undefined,
            title: undefined,
            type: undefined,
            sort: 'none'
          },
          sortOptions: [{ label: '--', key: 'none' }, { label: 'Nama A-Z', key: '+nama' }, { label: 'Nama Z-A', key: '-nama' }],
          total: null,
          page_size: 6,
          current_page: 1,
          multipleSelection: []
        }
      },
      methods: {
        getSummaries (param) {
          var { columns, data } = param
          var sums = []
          columns.forEach((column, index) => {
            if (index === 0) {
              sums[index] = 'TOTAL'
              return
            }

            var values = data.map(item => Number(item[column.property]))

            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                var value = Number(curr)
                if (!isNaN(value)) {
                  return prev + curr
                } else {
                  return prev
                }
              }, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            } else {
              sums[index] = ''
            }
          })

          return sums
        },
        toMoney (x) {
          var parts = x.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          return parts.join('.')
        },
        querySearch: function (queryString, cb) {
          var links = this.region.slice()
          var results = queryString ? links.filter(this.createFilter(queryString)) : links
          cb(results)
        },
        createFilter (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelect (item) {
          this.row1.kode_toko = item
        },
        querySearch1: function (queryString, cb) {
          var links = this.region.slice()
          var results = queryString ? links.filter(this.createFilter(queryString)) : links
          cb(results)
        },
        createFilter1 (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelect1 (item) {
          this.kode_toko = item
          // this.getData()
        },
        handleSelectionChange (val) {
          this.multipleSelection = val
          this.row1.nama = ''
          for (var i = 0; i < this.multipleSelection.length; i++) {
            this.row1.nama += this.multipleSelection[i].nama + ';'
          }
        },
        handleSelect_: function () {
          var nama = this.carinama
          var newArray = this.pegawai1.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nama
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.pegawai = newArray1.slice()
        },
        handleClose (done) {
          this.$refs['multipleTable'].clearSelection()
          done()
        },
        resetForm (formName) {
          if (this.$refs[formName] !== undefined) {
            this.$refs[formName].resetFields()
          }
        },
        clearForm: function () {
          this.row1 = {kode: '', nama: '', edit: true, kode_barang: '', kode_toko: ''}
          this.region1 = ''
          this.resetForm('formAdd')
        },
        handleCurrentChangePegawai (val) {
          this.row1.nama = val.nama
          this.row1.kode_barang = val.kode
        },
        cariNama () {
          var nama = this.cari_nama
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nama
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariSisaStok () {
          var nama = this.cari_sisa_stok + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.sisa_stok + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariSku () {
          var nama = this.cari_sku
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.sku
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleFilter () {
          var byNama = this.tableData.slice(0)
          if (this.listQuery.sort === '+nama') {
            byNama.sort(function (a, b) {
              var x = a.nama.toLowerCase()
              var y = b.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.listQuery.sort === '-nama') {
            byNama.sort(function (a, b) {
              var x = b.nama.toLowerCase()
              var y = a.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else {
            byNama = this.tableData2.slice(0)
          }
          this.tableData = byNama.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleCurrentChange: function (val) {
          this.current_page = val
          this.tableData1 = []
          var a = (this.current_page - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData.length) {
            b = this.tableData.length
          }
          this.tableData1.push({kode: '', edit: true, nama: ''})
          for (var i = a; i < b; i++) {
            this.tableData1.push(this.tableData[i])
          }
        },
        submitForm: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('submit!')
            } else {
              console.log('error submit!!')
              return false
            }
          })
        },
        addData: function () {
          // this.tableData1.unshift({kode: '', nama: '', edit: true})
          this.dialogFormVisible = true
          this.clearForm()
        },
        confirmDet: function (row) {
          this.$router.push('/area/' + row.kode + '/' + row.nama)
        },
        confirmEdit: function (j, row) {
          this.dialogFormEdit = true
          this.resetForm('formEdit')
          this.row1.kode = row.kode
          this.row1.nama = row.nama
          this.row1.kode_toko = row.kode_toko
          this.row1.kode_barang = row.kode_barang
          this.region1 = this.toko1
        },
        cancelEdit: function (j, row) {
          if (row.kode !== '') {
            row.nama = row.nama1
            var item = this.tableData1[j]
            item.edit = false
            this.$set(this.tableData1, j, item)
          } else {
            this.tableData1.splice(j, 1)
          }
        },
        confirmEdit1: function (j, row, formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (row.kode !== '') {
                this.loadingModalEdit = true
              } else {
                this.loadingModalAdd = true
              }
              this.dialogFormVisible = false
              this.dialogFormEdit = false

              var req = ''
              var action = '/'
              if (row.kode !== '') {
                req = {kode: row.kode, kode_toko: this.row1.kode_toko, kode_barang: this.row1.kode_barang}
                action += 'update'
              } else {
                var items = []
                for (var i = 0; i < this.multipleSelection.length; i++) {
                  items.push({kode_barang: this.multipleSelection[i].kode})
                }
                req = {kode_toko: this.row1.kode_toko, item: items}
                action += 'create_array'
              }
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.barang_toko + action

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormWilEdit = false
                  this.getData()
                  this.loadingModalEdit = false
                  this.loadingModalAdd = false
                  // this.clearForm()
                  this.message = response.body
                  this.dialogFormInfo = true
                  this.$refs['multipleTable'].clearSelection()
                }
              }, response => {
                // error callback
                this.dialogFormWilEdit = false
                this.loadingModalEdit = false
                this.loadingModalAdd = false
                this.$refs['multipleTable'].clearSelection()
                // this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        confirmDel: function (row) {
          this.form1.kode = row.kode
          this.nama = row.nama
          this.dialogFormWilDel = true
        },
        confirmDel1: function () {
          this.loadingModalDel = true
          var req = {kode: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.barang_toko + '/delete'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormWilDel = false
              this.loadingModalDel = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormWilDel = false
            this.loadingModalDel = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        confirmStok: function (row) {
          // this.stok = []
          // this.dialogStok = true
          // this.loadingModalStok = true
          // var req = {kode_toko: this.kode_toko, kode_barang: row.kode_barang, bulan: moment(this.value4).format('YYYY-MM')}
          // var req1 = JSON.stringify(req)

          // var url = Vue.cookie.get('url') + '/' + jsonUrl.barang_toko + '/kartu_stok'

          // Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
          //   // console.log('response ' + JSON.stringify(response.body))
          //   // if (response.body.status === "SUCCESS") {}
          //   if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
          //     this.$router.push('/login')
          //   } else {
          //     this.loadingModalStok = false
          //     this.title_stok = 'KARTU STOK ' + response.body.keterangan
          //     this.stok = response.body.data.slice()
          //     for (var i = 0; i < this.stok.length; i++) {
          //       this.stok[i].no = i + 1
          //     }
          //   }
          // }, response => {
          //   // error callback
          //   this.loadingModalStok = false
          // })
          // this.dialogFormWilDel = false
          this.dialogStok = true
          this.kode_barang = row.kode_barang
          this.hitKartuStokService()
        },
        hitKartuStokService: function () {
          this.stok = []
          this.loadingModalStok = true
          var req = {kode_toko: this.kode_toko, kode_barang: this.kode_barang, bulan: moment(this.value4).format('YYYY-MM')}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.barang_toko + '/kartu_stok'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalStok = false
              this.title_stok = 'KARTU STOK ' + response.body.keterangan
              this.stok = response.body.data.slice()
              for (var i = 0; i < this.stok.length; i++) {
                this.stok[i].no = i + 1
              }
            }
          }, response => {
            // error callback
            this.loadingModalStok = false
          })
        },
        getData: function () {
          this.fullscreenLoading = true
          this.tableData = []
          this.tableData1 = []
          var c = this.current_page
          var req = {kode_toko: this.kode_toko}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.barang_toko + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.tableData = response.body.data.slice()
              this.total = this.tableData.length
              for (var i = 0; i < this.tableData.length; i++) {
                this.tableData[i].edit = false
                this.tableData[i].no = i + 1
              }
              this.tableData2 = this.tableData.slice()
              var a = 0
              var b = a + this.page_size
              if (b > this.tableData.length) {
                b = this.tableData.length
              }
              for (var j = a; j < b; j++) {
                this.tableData1.push(this.tableData[j])
              }
              this.current_page = c
              this.handleCurrentChange(c)
            }
            this.fullscreenLoading = false
          }, response => {
            // error callback
            this.loadingModal = false
            this.fullscreenLoading = false
          })
        },
        getData1: function () {
          // this.loadingModal = true
          this.region = []
          this.tableData = []
          this.tableData1 = []
          var req = {}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/read_simple'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.region = response.body.data.slice()
              for (var i = 0; i < this.region.length; i++) {
                this.region[i].value = this.region[i].kode + ''
                this.region[i].label = this.region[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.barang + '/read_simple'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.pegawai = response.body.data.slice()
              for (var i = 0; i < this.pegawai.length; i++) {
                this.pegawai[i].kode = this.pegawai[i].kode + ''
              }
              this.pegawai1 = this.pegawai.slice()
            }
          }, response => {
            // error callback
          })
        }
      },
      mounted () {
        // if (localStorage.username !== 'root') {
        //   this.$router.replace('/toko')
        // }
        this.loadingModal = true
        this.getData()
        this.getData1()
      }
    }
</script>

<style>
  .edit-input {
    padding-right: 100px;
  }
  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
</style>



// WEBPACK FOOTER //
// BarangToko1.vue?046f204a